enum UserPermissions {
  "Company.View" = "Company.View",
  "Company.Upsert" = "Company.Upsert",
  "Company.Remove" = "Company.Remove",
  "Item.View" = "Item.View",
  "Item.Upsert" = "Item.Upsert",
  "Item.Remove" = "Item.Remove",
  "Estimate.View" = "Estimate.View",
  "Estimate.Upsert" = "Estimate.Upsert",
  "User.Upsert" = "User.Upsert",
  "Vehicle.View" = "Vehicle.View",
  "Vehicle.Upsert" = "Vehicle.Upsert",
  "Vehicle.Remove" = "Vehicle.Remove",
  "Equipment.View" = "Equipment.View",
  "Equipment.Upsert" = "Equipment.Upsert",
  "Equipment.Remove" = "Equipment.Remove",
  "WorkOrder.View" = "WorkOrder.View",
  "WorkOrder.Upsert" = "WorkOrder.Upsert",
  "WorkOrder.Execute" = "WorkOrder.Execute",
  "Settings.Update" = "Settings.Update",
  "Payroll.View.Own" = "Payroll.View.Own",
  "Payroll.View.All" = "Payroll.View.All",
  "Payroll.Upsert" = "Payroll.Upsert",
  "Payroll.Remove" = "Payroll.Remove",
  "Role.Upsert" = "Role.Upsert",
  "Role.Remove" = "Role.Remove",
  "GlobalAdmin" = "GlobalAdmin",
  "Feature.Update" = "Feature.Update",
  "Calendar.View" = "Calendar.View",
  "Calendar.Upsert" = "Calendar.Upsert",
  "Calendar.Remove" = "Calendar.Remove",
  "Vendor.View" = "Vendor.View",
  "Vendor.Upsert" = "Vendor.Upsert",
  "Vendor.Remove" = "Vendor.Remove",
}

export {
  // eslint-disable-next-line import/prefer-default-export
  UserPermissions,
};
